import React from 'react';
import api from '../../helpers/api';
import styles from './TreatmentSettings.module.scss';
import MultiSelect from '../miscellaneous/MultiSelect/MultiSelect';
import Tooltip from '../miscellaneous/Tooltip/Tooltip';
import {Link} from 'react-router-dom';
import {$t} from '../../helpers/translator';
import {FiInfo} from 'react-icons/fi';
import {connect} from "react-redux";
import {getUserClinic} from "../../store/auth-slice";
import WorkingMode from "../miscellaneous/WorkingMode/WorkingMode";

class TreatmentSettings extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            clinicId: this.props.clinicId ? this.props.clinicId : null, //for specific clinic data (when connected as chain)
            userType: 2,

            selected: {
                preparation_time: null,
                fluence_deviation: null,
                energy_deviation: null,
                treatment_saved_data: null,
            },

            options: {
                preparation_time: [],
                fluence_deviation: [],
                energy_deviation: [],
                treatment_saved_data: [],
            }
        };
    }

    async componentDidMount() {
        let userType = this.props.userType ? this.props.userType : 2;   //fallback to type clinic if not provided
        this.setState({userType: userType}, async () => {
            await this.getData();
        })
    }

    async getData() {
        try {
            let clinic = null;

            if (this.props.clinicId) {
                let res = await api.get(`account/clinic?clinic_id=${this.props.clinicId}`);
                if (res && res.success) {
                    clinic = res.data.data;
                }
            } else {
                clinic = await this.props.dispatch(getUserClinic())
            }

            if (!clinic) {
                return;
            }

            let selected = {
                preparation_time: clinic.preparation_time,
                fluence_deviation: clinic.fluence_deviation,
                energy_deviation: clinic.energy_deviation,
                treatment_saved_data: clinic.cur_treat_rec_type_permiss_id,
            };

            this.setState({
                selected: selected,
                clinicId: clinic.id,
                isUnderChain: !!clinic.parent_clinic
            });
            this.buildOptions();
            // }
        } catch (e) {
            console.error('err account', e);
        }
    }

    buildOptions() {
        let options = {
            preparation_time: [],
            fluence_deviation: [],
            energy_deviation: [],
            treatment_saved_data: [
                {
                    value: 1,
                    label: $t('global.account.treatmentSettings.staffIdAndPatientId'),
                    explanation: $t('global.account.treatmentSettings.staffIdAndPatientIdExplained')
                },
                {
                    value: 2,
                    label: $t('global.account.treatmentSettings.staffId'),
                    explanation: $t('global.account.treatmentSettings.staffIdExplained')
                },
                {
                    value: 3,
                    label: $t('global.account.treatmentSettings.patientId'),
                    explanation: $t('global.account.treatmentSettings.patientIdExplained')
                },
                {
                    value: 4,
                    label: $t('global.account.treatmentSettings.noAdditionalData'),
                    explanation: $t('global.account.treatmentSettings.noAdditionalDataExplained')
                },
            ]
        };

        for (let i = 0; i < 7; i++) {
            options.preparation_time.push({
                label: i * 5 + ' ' + $t('global.dateTime.minutes'),
                value: i * 5
            });
        }
        for (let i = 3; i < 11; i++) {
            options.fluence_deviation.push({
                label: i * 5 + '%',
                value: i * 5
            });
            options.energy_deviation.push({
                label: i * 5 + '%',
                value: i * 5
            });
        }

        this.setState({options: options});
    }

    async valueChangeHandler(key, data) {
        let selected = {...this.state.selected};
        selected.clinic_id = this.props.clinicId;

        let oldSelected = {...this.state.selected};
        selected[key] = data.value;

        this.setState({selected: selected}, async () => {
            try {
                // let res = await api.updateClinicAccount(selected);
                let res = await api.post('/account', selected);
                if (res && res.data && res.data.success) {
                    // console.log('SUCCESSSS!!!')
                } else {
                    this.setState({selected: oldSelected});
                }
            } catch (e) {
                console.error('err updating ', e);
                this.setState({selected: oldSelected});
            }
        });
    }

    async savedDataChangeHandler(data) {
        let selected = {...this.state.selected};
        let oldSelected = {...this.state.selected};
        selected['treatment_saved_data'] = data.value;

        this.setState({selected: selected}, async () => {
            try {
                // let res = await api.updateTreatRecTypePermission(this.state.clinicId, data.value);
                let res = await api.post('/account/change/machine/permission', {
                    clinic_id: this.state.clinicId,
                    treat_rec_type_permiss_id: data.value
                });
                if (res && res.data && res.data.success) {
                } else {
                    this.setState({selected: oldSelected});
                }
            } catch (e) {
                console.error('err updating ', e);
                this.setState({selected: oldSelected});
            }
        });

    }

    render() {
        let userType = this.props.userType ? this.props.userType : this.state.userType;

        // console.log('userType', userType, userType === 2 && this.state.isUnderChain || userType === 3);
        return (

            <div className={`alma-box ${styles['container']}`}>
                <div className={'alma-box-header'}>
                    <span><h3>{$t('global.account.treatmentSettings.treatmentSettings')}</h3></span>
                    {
                        ((userType === 2 && this.state.isUnderChain) || (userType === 3)) ?
                            <Tooltip
                                content={this.props.userType === 3 ? $t('global.account.managedForAllYourClinics') : $t('global.account.managedByYourChain')}>
                                <FiInfo className={`${styles['info-icon']}`}/>
                            </Tooltip>
                            :
                            null
                    }
                </div>
                <div>

                    <div>
                        <div className={`${styles['row']} ${styles['flex']} ${styles['name']}`}>
                            <div className={`${styles['flex']} ${styles['textMinWidth']}`}>
                                <Tooltip
                                    content={$t('global.account.treatmentSettings.preparationTimeExplained')}>
                                    <FiInfo className={`${styles['info-icon']}`}/>
                                </Tooltip>
                                <div className={`${styles['flex']}`}>
                                    <div>{$t('global.account.treatmentSettings.preparationTime')}:</div>
                                </div>
                            </div>
                            <div className={`${styles['select']}`}>
                                <MultiSelect
                                    disabled={userType === 2 && this.state.isUnderChain || userType === 3 && this.props.clinicId || userType === 4}
                                    selected={{
                                        label: this.state.selected.preparation_time + ' ' + $t('global.dateTime.minutes'),
                                        value: this.state.selected.preparation_time,
                                    }}
                                    options={this.state.options.preparation_time}
                                    onValueChange={(data) => this.valueChangeHandler('preparation_time', data)}
                                />
                            </div>

                        </div>
                        <div className={`${styles['row']} ${styles['flex']} ${styles['name']}`}>
                            <div className={`${styles['flex']} ${styles['textMinWidth']}`}>
                                <Tooltip
                                    content={$t('global.account.treatmentSettings.allowedFluenceDeviationExplained')}>
                                    <FiInfo className={`${styles['info-icon']}`}/>
                                </Tooltip>
                                <div className={`${styles['flex']}`}>
                                    <div>{$t('global.account.treatmentSettings.allowedFluenceDeviation')}:
                                    </div>
                                </div>
                            </div>
                            <div className={`${styles['select']}`}>
                                <MultiSelect
                                    disabled={userType === 2 && this.state.isUnderChain || userType === 3 && this.props.clinicId || userType === 4}
                                    selected={{
                                        label: this.state.selected.fluence_deviation + '%',
                                        value: this.state.selected.fluence_deviation,
                                    }}
                                    options={this.state.options.fluence_deviation}
                                    onValueChange={(data) => this.valueChangeHandler('fluence_deviation', data)}
                                />
                            </div>
                        </div>

                        <div className={`${styles['row']} ${styles['flex']} ${styles['name']}`}>
                            <div className={`${styles['flex']} ${styles['textMinWidth']}`}>
                                <Tooltip
                                    content={$t('global.account.treatmentSettings.allowedEnergyDeviationExplained')}>
                                    <FiInfo className={`${styles['info-icon']}`}/>
                                </Tooltip>
                                <div className={`${styles['flex']}`}>
                                    <div>{$t('global.account.treatmentSettings.allowedEnergyDeviation')}:
                                    </div>
                                </div>
                            </div>
                            <div className={`${styles['select']}`}>
                                <MultiSelect
                                    disabled={userType === 2 && this.state.isUnderChain || userType === 3 && this.props.clinicId || userType === 4}
                                    selected={{
                                        label: this.state.selected.energy_deviation + '%',
                                        value: this.state.selected.energy_deviation,
                                    }}
                                    options={this.state.options.energy_deviation}
                                    onValueChange={(data) => this.valueChangeHandler('energy_deviation', data)}
                                />
                            </div>
                        </div>
                    </div>

                    <div className={`${styles['row']} ${styles['flex']}`} style={{display: 'block'}}>
                        <div className={`${styles['row']} ${styles['flex']} ${styles['name']}`} style={{
                            padding: 0,
                            margin: 0
                        }}>
                            <div className={`${styles['flex']} ${styles['textMinWidth']}`}>
                                <Tooltip
                                    content={$t('global.account.treatmentSettings.treatmentSavedDataOptionsExplained')}>
                                    <FiInfo className={`${styles['info-icon']}`}/>
                                </Tooltip>
                                <div className={`${styles['flex']}`}>
                                    <div>{$t('global.account.treatmentSettings.treatmentSavedDataOptions')}:
                                    </div>
                                </div>
                            </div>
                            <div className={`${styles['select']}`}>
                                <MultiSelect
                                    disabled={userType === 2 && this.state.isUnderChain}
                                    selected={{
                                        label: this.state.options.treatment_saved_data && this.state.options.treatment_saved_data[this.state.selected.treatment_saved_data - 1] ? this.state.options.treatment_saved_data[this.state.selected.treatment_saved_data - 1].label : '',
                                        value: this.state.selected.treatment_saved_data,
                                    }}
                                    options={this.state.options.treatment_saved_data}
                                    onValueChange={(data) => this.savedDataChangeHandler(data)}
                                />
                            </div>
                        </div>
                        <div className={styles.flexRow}>
                            <div>
                                <WorkingMode mode={this.state.selected.treatment_saved_data}/>
                            </div>
                            <div
                                className={`${styles['selection-explain']}`}>{$t('global.workingModes.' + this.state.selected.treatment_saved_data)}</div>
                        </div>

                    </div>

                    {userType >= 4 ?
                        null
                        :
                        <div className={`${styles['row']} ${styles['flex']} ${styles['name']}`}>
                            <div className={`${styles['flex']}`}>
                                <Tooltip
                                    content={$t('global.account.treatmentSettings.viewAndEditTreatmentProtocols')}>
                                    <FiInfo className={`${styles['info-icon']}`}/>
                                </Tooltip>
                                <div className={`${styles['flex']}`}>
                                    <div>{$t('global.account.treatmentSettings.treatmentProtocols')}:
                                    </div>
                                </div>
                            </div>
                            <div className={`${styles['select']}`}>
                                <Link to={'/parameters'}>
                                    <div className={'alma-button'}
                                         style={{margin: 0,}}>{$t('global.account.treatmentSettings.view')}</div>
                                </Link>
                            </div>
                        </div>
                    }
                </div>
            </div>
        );
    }
}

// export default ClinicTreatmentSettings;
const mapStateToProps = (state) => ({
    state: state
});

export default connect(mapStateToProps)(TreatmentSettings);
